import React from 'react';
import BodyText from "src/presentation/components/ui/BodyText";
import Button from "src/presentation/components/ui/Button";
import WhiteBox from "src/presentation/components/ui/WhiteBox";
import styled, {css} from "styled-components";
import {iconKey, iconUser, imageLogo} from "src/integration/assets/AssetsProvider";
import Image from "src/presentation/components/Image";
import Input from "src/presentation/components/Input";
import useLoginForm from "src/toolkit/forms/useLoginForm";
import breakpoints from "src/integration/styles/breakpoints";
import colors from 'src/integration/styles/colors';
import ErrorText from 'src/presentation/components/ErrorText';

const Root = styled.div`
  ${() => css`
      text-align: center;

      ${breakpoints.mobile`
         margin-top: 80px;
      `}

      ${breakpoints.desktop`
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        `}

      ${breakpoints.desktopLarge`
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        `}

      ${breakpoints.desktopLarge4K`
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        `}
    `}
`;

const StyledWhiteBox = styled(WhiteBox)`
  ${() => css`
      display: flex;
      flex-direction: column;
      gap: 40px;
      align-items: center;
      margin: auto;
      padding: 32px 24px;


      ${breakpoints.mobile`
            border: none;
            background: transparent;
        `}

      ${breakpoints.desktop`
           width: 391px;
        `}

      ${breakpoints.desktopLarge`
           width: 391px;
        `}

      ${breakpoints.desktopLarge4K`
           width: 391px;
        `}
  `}
`;

const LoginBox = styled.div`
  ${() => css`
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 16px;
  `}
`;

const StyledButton = styled(Button)`
  ${() => css`
      width: 100%;
  `}
`;

const LoginPage = () => {
  const { register, handleFormSubmission,  errors, loginError, isLoading} = useLoginForm();

  return (
      <Root>
          <Image icon={imageLogo} size={45} mb={57}/>
          <StyledWhiteBox>
              <BodyText level={'b1-med'} color={colors.grey2}>Login to your account</BodyText>
              <LoginBox>
                  <Input
                      type="text"
                      name={`username`}
                      placeholder={'Username'}
                      register={register}
                      errors={errors?.username?.message ?? undefined}
                      leftIcon={iconUser}
                  />
                  <Input
                      type="password"
                      name={`password`}
                      placeholder={'Password'}
                      register={register}
                      errors={errors?.password?.message ?? undefined}
                      leftIcon={iconKey}
                  />
                {loginError && <ErrorText error={loginError} />}
              </LoginBox>
            <StyledButton onClick={handleFormSubmission} isLoading={isLoading} disabled={isLoading}>LOGIN</StyledButton>
          </StyledWhiteBox>
      </Root>);

};

export default LoginPage;
